var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVmojiOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C12 3.55228 11.5523 4 11 4C7.13401 4 4 7.13401 4 11C4 11.5523 3.55228 12 3 12C2.44771 12 2 11.5523 2 11C2 6.02944 6.02944 2 11 2C11.5523 2 12 2.44771 12 3Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 25C12 24.4477 11.5523 24 11 24C7.13401 24 4 20.866 4 17C4 16.4477 3.55228 16 3 16C2.44772 16 2 16.4477 2 17C2 21.9706 6.02944 26 11 26C11.5523 26 12 25.5523 12 25Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11C10.7165 11 11.5 11.7835 11.5 12.75C11.5 13.7165 10.7165 14.5 9.75 14.5C8.7835 14.5 8 13.7165 8 12.75C8 11.7835 8.7835 11 9.75 11ZM16.8952 11.8781C17.9284 11.3223 19.1195 11.3223 20.169 12.2632C20.5795 12.6313 20.6128 13.2612 20.2433 13.6702C19.8738 14.0792 19.2415 14.1123 18.831 13.7442L18.7306 13.662C18.4329 13.4418 18.1657 13.459 17.8455 13.6313C17.7487 13.6833 17.6835 13.7312 17.669 13.7442L17.5705 13.8221C17.1627 14.105 16.5977 14.0477 16.2567 13.6702C15.8872 13.2612 15.9205 12.6313 16.331 12.2632C16.4554 12.1518 16.6448 12.0128 16.8952 11.8781Z",
    fill: "#023F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.5C16.5523 16.5 16.9994 16.9495 16.9212 17.4963C16.8842 17.7554 16.8342 17.997 16.7716 18.1481C16.6209 18.512 16.3999 18.8427 16.1213 19.1213C15.8427 19.3999 15.512 19.6209 15.1481 19.7716C14.7841 19.9224 14.394 20 14 20C13.606 20 13.2159 19.9224 12.8519 19.7716C12.488 19.6209 12.1573 19.3999 11.8787 19.1213C11.6001 18.8427 11.3791 18.512 11.2284 18.1481C11.1658 17.997 11.1158 17.7554 11.0788 17.4963C11.0006 16.9495 11.4477 16.5 12 16.5H16Z",
    fill: "#023F80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3C16 3.55228 16.4477 4 17 4C20.866 4 24 7.13401 24 11C24 11.5523 24.4477 12 25 12C25.5523 12 26 11.5523 26 11C26 6.02944 21.9706 2 17 2C16.4477 2 16 2.44771 16 3Z",
    fill: "#023F80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25C16 24.4477 16.4477 24 17 24C20.866 24 24 20.866 24 17C24 16.4477 24.4477 16 25 16C25.5523 16 26 16.4477 26 17C26 21.9706 21.9706 26 17 26C16.4477 26 16 25.5523 16 25Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVmojiOutline);
export default __webpack_public_path__ + "static/media/vmoji_outline.a1a528bb43953973250ed9eda3e4fc3a.svg";
export { ForwardRef as ReactComponent };